import { _ } from "../../../polyglot/polyglot.js";
import { displayLabels } from "../../../../models/wysiwygEditor/builders/helpers.js";
import { select } from "../../../elements/index.js";
import regionWidget from "../../regionWidget.js";

/**
 * Build an input value popover section to pick what to render.
 *
 * @param {string} display - Originally selected display option
 * @param {function} onChange - Function triggered when the user change the
 *   selection
 * @param {predicate} shouldShowFn - When false, "hides" the section. Since
 *   popover can't be resized while rendered, it will grey out the section
 */
export default function displaySectionBuilder({
	display,
	onChange,
	shouldShowFn = () => true,
}) {
	return regionWidget({
		content: (html) => {
			html.div(
				{
					class: [
						"display-options",
						"popover-section",
						{ disabled: !shouldShowFn() },
					],
				},
				html.div(
					{
						klass: "right-menu-block",
						"data-test": "display-options",
					},
					html.span({ klass: "display-label" }, _("Display")),
					html.div(
						select({
							items: Object.keys(displayLabels).map((key) => ({
								value: key,
								selected: key === display,
								label: displayLabels[key],
							})),
							onChange,
						}),
					),
				),
			);
		},
	});
}
